import Image from '../Image';

import style from './style.module.css';

export default function ImageGroup({ images, direction }) {
	
	const cn = [
		style.imageGroup,
		style[direction]
	].join(' ').trim();
	
	return (
		<section class={cn}>
			{images.map(image => {
				return (
					<Image
						key={image.id}
						src={image.src}
						alt={image.alt}
					/>
				);
			})}
		</section>
	);
}
